import { useSearchAnalysesWhereClause } from '@modules/feed/hooks';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { FieldNames } from 'v2/core/entities/fields';
import { EQLProps, ExpressionType } from 'v2/core/repository/eql/types';
import { useGetUser } from 'v2/core/services/user';
import { getGroupBy } from './getGroupBy';

export function useSearchAnalysesEqlPropsBy(fieldName: FieldNames) {
  const {
    tenant: { timezone },
  } = useGetUser();
  const taxonomyID = useTaxonomyStore(({ taxonomyID }) => taxonomyID ?? '');

  const expressionType = ExpressionType.Aggregates;
  const dateRange = useSearchStore(({ query: { duration } }) => duration);
  const whereClause: EQLProps['whereClause'] = useSearchAnalysesWhereClause();
  const groupBy = getGroupBy(fieldName);

  return {
    timezone,
    taxonomyID,
    expressionType,
    whereClause,
    dateRange: dateRange as EQLProps['dateRange'],
    groupBy,
  };
}
